<template>
  <transition
    name="modal"
    appear
    v-if="deleteConfirmModal"
    @before-enter="handleResetProperties"
    @after-leave="handleIsPostData"
  >
    <div class="main-modal main-modal-overlay" @click.self="handleCloseModal">
      <div class="main-modal-window">
        <div class="main-modal-container">
          <h2
            class="
              text-center
              font-weight-bold
              d-flex
              justify-content-center
              align-items-center
              u-mb30
            "
            style="color: #3c4b64; font-size: 16px"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="29.253"
              height="27"
              viewBox="0 0 29.253 27"
              class="u-mr20"
            >
              <path
                id="Icon_ionic-ios-warning"
                data-name="Icon ionic-ios-warning"
                d="M16.095,5.618,3.642,28.343A2.137,2.137,0,0,0,5.548,31.5H30.459a2.142,2.142,0,0,0,1.905-3.157L19.905,5.618A2.183,2.183,0,0,0,16.095,5.618Zm3.143,9.429-.253,8.578H17.016l-.253-8.578ZM18,28.294A1.295,1.295,0,1,1,19.343,27,1.306,1.306,0,0,1,18,28.294Z"
                transform="translate(-3.375 -4.5)"
                fill="#ffc400"
              />
            </svg>
            <span>児童情報を削除します</span>
          </h2>
          <p class="u-mb30">
            削除を行うと、過去の連絡帳、実績記録、業務日誌、請求データなど全ての情報が削除されるため、閲覧・参照ができなくなります。法定保管期間（5年）は削除されないことを推奨しますが、削除してよろしいですか？<br />削除する場合は、テキストボックスに「削除」と入力して削除ボタンをクリックしてください。
          </p>
        </div>
        <input
          type="text"
          class="form-control u-mb30 u-mt30"
          placeholder="「削除」と入力してください。"
          @input="handleCheckInput"
          :value="deleteKeyword"
        />
        <div class="d-flex flex-column">
          <div class="main-modal-button">
            <button
              type="button"
              class="btn w-100 font-weight-bold"
              :class="[
                deleteKeyword === '削除' ? 'btn-danger' : 'btn-secondary',
              ]"
              style="font-size: 16px"
              :disabled="isDisabled"
              @click="handleCloseModalDelete"
            >
              削除する
            </button>
          </div>
          <div class="main-modal-button">
            <button
              type="button"
              class="btn w-100 btn-secondary font-weight-bold"
              style="font-size: 16px"
              @click="handleCloseModal"
            >
              キャンセル
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    deleteConfirmModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      deleteKeyword: '',
      isDisabled: true,
      isChildDelete: false,
    }
  },
  methods: {
    handleCloseModal() {
      this.$emit('close-child-delete-modal')
    },
    handleCheckInput(e) {
      this.deleteKeyword = e.target.value

      if (this.deleteKeyword === '削除') {
        this.isDisabled = false
      } else {
        this.isDisabled = true
      }
    },
    handleCloseModalDelete() {
      this.isChildDelete = true
      this.handleCloseModal()
    },
    handleIsPostData() {
      if (this.isChildDelete) {
        this.$emit('update-delete')
      }
    },
    handleResetProperties() {
      this.deleteKeyword = ''
      this.isChildDelete = false
      this.isDisabled = true
    },
  },
}
</script>

<style lang="scss" scoped>
.main-modal {
  &-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 10000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
  }

  &-window {
    width: 40%;
    min-width: 400px;
    margin: auto;
    background: #fff;
    border-radius: 5px;
    overflow: hidden;
    font-size: 13px;
    padding: 26px 20px;
  }

  &-container {
    &_block {
      margin-bottom: 5px;
      text-align: left;
      p {
        margin: 0;
        display: inline-block;
        font-weight: bold;
        color: $base_text_color;
        font-size: 14px;
        padding: 5px 5px;
      }
      &_child {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        p {
          width: calc((100% - 100px) / 3);
        }
      }
    }
  }
  &-button {
    padding: 0 0 10px;
    &_item {
      button {
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        padding: 8px;
        box-sizing: border-box;
        border-radius: 5px;
        outline: none;
        border: none;
      }
      .cancel {
        color: $base_text_color;
        margin-bottom: 10px;
        background: none;
      }
      .done {
        position: relative;
        background: $button_color;
        color: #ffffff;
        border-radius: 50px;
        box-shadow: $box_shadow;
        svg {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translate(0, -50%);
        }
      }
    }
  }
}

// オーバーレイのトランジション
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.4s;

  // オーバーレイに包含されているモーダルウィンドウのトランジション
  .modal-window {
    transition: opacity 0.4s, transform 0.4s;
  }
}

// ディレイを付けるとモーダルウィンドウが消えた後にオーバーレイが消える
.modal-leave-active {
  transition: opacity 0.4s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;

  .modal-window {
    opacity: 0;
    transform: translateY(-20px);
  }
}
</style>
